import BackNavigation from '@components/backNavigation'
import Column from '@components/column'
import Image from '@components/image'
import Row from '@components/row'
import SvgImage from '@components/svg'
import Typography from '@components/typography'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import useWindowSize from '../../../hooks/useWindow'
import {
  AgentColumn,
  AgentIconWrapper,
  AgentImageWrapper,
  EachContact,
  StyleContacts,
  SupportAgentWrapper,
} from './style'
import { GeneralSetting } from '@apis/index'
import icons from '@assets/icons'

interface SupportAgent {
  avatar: string | null
  whatsAppNo: string
  phoneNo: string
  name: string
  messageNo: string
}

interface OfficeDetail {
  callCenterNo: string
  email: string
  location: string
}

const Support = () => {
  const { width } = useWindowSize()
  const navigate = useNavigate()
  const [agentDetails, setAgentDetails] = useState<SupportAgent>({
    avatar: null,
    whatsAppNo: '',
    phoneNo: '',
    name: '',
    messageNo: '',
  })
  const [officeDetails, setOfficeDetails] = useState<OfficeDetail>({
    callCenterNo: '',
    email: '',
    location: '',
  })

  const supportAgent = useSelector((state: any) => state.supportAgent?.data)
  const officeDetail = useSelector((state: any) => state.officeDetail?.data)

  useEffect(() => {
    if (!officeDetail?.id)
      GeneralSetting.getByKey('officeDetail', 'officeDetail').catch(() => {})
    if (!supportAgent?.id)
      GeneralSetting.getByKey('supportAgent', 'supportAgent').catch(() => {})
  }, [])

  useEffect(() => {
    if (supportAgent?.id) {
      const agentValue = supportAgent.value
        ? JSON.parse(supportAgent.value)
        : {}
      setAgentDetails({
        avatar: agentValue?.avatar || null,
        name: agentValue?.name || '',
        phoneNo: agentValue?.phoneNo || '',
        messageNo: agentValue?.messageNo || '',
        whatsAppNo: agentValue?.whatsAppNo || '',
      })
    }

    if (officeDetail?.id) {
      const officeValue = officeDetail.value
        ? JSON.parse(officeDetail.value)
        : {}
      setOfficeDetails({
        callCenterNo: officeValue?.callCenterNo || '',
        email: officeValue?.email || '',
        location: officeValue?.location || '',
      })
    }
  }, [supportAgent, officeDetail])

  const isPhoneScreen = width < 1024

  const handleClick = (type: string) => {
    const actions: Record<string, () => void> = {
      chatIcon: () =>
        agentDetails.whatsAppNo
          ? window.open(
              `https://wa.me/+977${agentDetails.whatsAppNo}`,
              '_blank',
            )
          : console.log('WhatsApp Number not available'),
      callIcon: () => {
        officeDetails.callCenterNo
          ? (window.location.href = `tel:+977${officeDetails.callCenterNo}`)
          : console.log('Call Center Number not available')
      },
      emailIcon: () => (window.location.href = `mailto:${officeDetails.email}`),
      supportLocationIcon: () =>
        window.open(
          `https://www.google.com/maps/search/${officeDetails.location}`,
          '_blank',
        ),
      call: () => {
        agentDetails.phoneNo
          ? (window.location.href = `tel:+977${agentDetails.phoneNo}`)
          : console.log('Agent Phone Number not available')
      },
      message: () => {
        agentDetails.messageNo
          ? (window.location.href = `sms:${agentDetails.messageNo}`)
          : console.log('Message Number not available')
      },
      whatsApp: () => {
        agentDetails.whatsAppNo
          ? window.open(
              `https://wa.me/+977${agentDetails.whatsAppNo}`,
              '_blank',
            )
          : console.log('WhatsApp Number not available')
      },
    }
    actions[type]?.()
  }

  return (
    <>
      <BackNavigation
        title="Support"
        onClick={() =>
          isPhoneScreen ? navigate('/books/account') : navigate(-1)
        }
      />
      <Column rowGap={20} alignItems="center">
        <StyleContacts>
          {[
            {
              svg: 'chatIcon',
              title: 'Support Chat',
              type: 'chatIcon',
              content: '24x7 Online Support',
            },
            {
              svg: 'callIcon',
              title: 'Call Center',
              type: 'callIcon',
              content: '24x7 Online Support',
            },
            {
              svg: 'emailIcon',
              title: 'Email',
              type: 'emailIcon',
              content: officeDetails.email,
            },
            {
              svg: 'supportLocationIcon',
              title: 'Location',
              type: 'supportLocationIcon',
              content: officeDetails.location,
            },
          ].map((item, index) => (
            <EachContact
              key={index}
              screenWidth={width}
              onClick={() => handleClick(item.type)}
            >
              <SvgImage src={item.svg as keyof typeof icons} />
              <div>
                <Typography variant="h4">{item.title}</Typography>
                <Typography variant="p">{item.content}</Typography>
              </div>
            </EachContact>
          ))}
        </StyleContacts>
        <SupportAgentWrapper>
          <AgentColumn hasBorder pb>
            <Row colGap={10} alignItems="center">
              <AgentImageWrapper>
                <Image
                  src={`${process.env.BUCKET_URL}/${supportAgent?.file}`}
                  customStyle={{ width: '100%', height: '100%' }}
                  fit="contain"
                />
              </AgentImageWrapper>
              <Column>
                <Typography variant="h4">{agentDetails.name}</Typography>
                <Typography variant="p" size={10} weigth={300} tc="greyText">
                  Support Agent
                </Typography>
              </Column>
            </Row>
          </AgentColumn>
          <AgentColumn pt>
            <Row colGap={20}>
              {['call', 'message', 'whatsApp'].map((type) => (
                <AgentIconWrapper key={type} onClick={() => handleClick(type)}>
                  <SvgImage src={type as keyof typeof icons} />
                </AgentIconWrapper>
              ))}
            </Row>
          </AgentColumn>
        </SupportAgentWrapper>
      </Column>
    </>
  )
}

export default Support
